export const vehicleCategories = {
  luxury: {
    name: 'Luxury',
    models: [
      'BMW 7 Series',
      'BMW 5 Series',
      'Mercedes S-Class',
      'Mercedes E-Class',
      'Audi A8',
      'Audi A6',
      'Lexus LS',
      'Lexus ES',
      'Genesis G90',
      'Genesis G80',
      'Cadillac CT6',
      'Cadillac CT5',
      'Lincoln Continental',
      'Jaguar XJ',
      'Jaguar XF',
      'Porsche Panamera',
      'Maserati Quattroporte',
      'Acura RLX',
      'Infiniti Q70'
    ]
  },
  suv: {
    name: 'SUV',
    models: [
      'BMW X5',
      'BMW X7',
      'Mercedes GLE',
      'Mercedes GLS',
      'Audi Q7',
      'Audi Q8',
      'Lexus GX',
      'Lexus LX',
      'Cadillac Escalade',
      'Cadillac XT6',
      'Lincoln Navigator',
      'Lincoln Aviator',
      'Range Rover',
      'Range Rover Sport',
      'Porsche Cayenne',
      'Porsche Macan',
      'Jeep Grand Cherokee',
      'Jeep Wagoneer',
      'Chevrolet Tahoe',
      'Chevrolet Suburban',
      'GMC Yukon',
      'Ford Expedition',
      'Acura MDX',
      'Infiniti QX80',
      'Volvo XC90'
    ]
  },
  sports: {
    name: 'Sports',
    models: [
      'BMW M3',
      'BMW M4',
      'BMW Z4',
      'Mercedes AMG GT',
      'Mercedes C63 AMG',
      'Audi R8',
      'Audi TT RS',
      'Porsche 911',
      'Porsche Cayman',
      'Porsche Boxster',
      'Chevrolet Corvette',
      'Chevrolet Camaro',
      'Ford Mustang',
      'Dodge Challenger',
      'Dodge Charger',
      'Nissan GT-R',
      'Toyota GR Supra',
      'Jaguar F-Type',
      'Lexus RC F',
      'Acura NSX'
    ]
  },
  electric: {
    name: 'Electric',
    models: [
      'Tesla Model S',
      'Tesla Model 3',
      'Tesla Model X',
      'Tesla Model Y',
      'BMW iX',
      'BMW i4',
      'Mercedes EQS',
      'Mercedes EQB',
      'Mercedes EQE',
      'Audi e-tron',
      'Audi Q4 e-tron',
      'Audi e-tron GT',
      'Lucid Air',
      'Porsche Taycan',
      'Genesis Electrified G80',
      'Genesis Electrified GV70',
      'Volvo XC40 Recharge',
      'Volvo C40 Recharge',
      'Ford F-150 Lightning',
      'Ford Mustang Mach-E',
      'Chevrolet Bolt EV',
      'Chevrolet Silverado EV',
      'Rivian R1T',
      'Rivian R1S',
      'Hyundai Ioniq 5',
      'Hyundai Ioniq 6',
      'Kia EV6',
      'Kia EV9',
      'Nissan Ariya',
      'Toyota bZ4X',
      'Subaru Solterra',
      'Cadillac Lyriq',
      'GMC Hummer EV'
    ]
  },
  compact: {
    name: 'Compact',
    models: [
      'BMW 3 Series',
      'BMW 2 Series',
      'Mercedes C-Class',
      'Mercedes CLA',
      'Audi A4',
      'Audi A3',
      'Lexus IS',
      'Lexus UX',
      'Genesis G70',
      'Volvo S60',
      'Acura TLX',
      'Acura ILX',
      'Infiniti Q50',
      'Infiniti QX55',
      'Honda Accord',
      'Honda Civic',
      'Toyota Camry',
      'Toyota Corolla',
      'Hyundai Elantra',
      'Hyundai Sonata',
      'Kia K5',
      'Kia Forte',
      'Mazda3',
      'Mazda6',
      'Subaru Legacy',
      'Subaru Impreza',
      'Volkswagen Jetta',
      'Volkswagen Passat'
    ]
  },
  pickup: {
    name: 'Pickup',
    models: [
      'Ford F-150',
      'Ford F-250 Super Duty',
      'Ford Maverick',
      'Chevrolet Silverado 1500',
      'Chevrolet Silverado 2500HD',
      'Ram 1500',
      'Ram 2500',
      'Toyota Tundra',
      'Toyota Tacoma',
      'GMC Sierra 1500',
      'GMC Sierra HD',
      'Nissan Titan',
      'Nissan Frontier',
      'Honda Ridgeline'
    ]
  },
  crossover: {
    name: 'Crossover',
    models: [
      'Honda CR-V',
      'Honda HR-V',
      'Toyota RAV4',
      'Toyota Venza',
      'Nissan Rogue',
      'Nissan Murano',
      'Ford Escape',
      'Ford Edge',
      'Chevrolet Equinox',
      'Chevrolet Blazer',
      'Hyundai Tucson',
      'Hyundai Santa Fe',
      'Hyundai Kona',
      'Kia Sportage',
      'Kia Sorento',
      'Mazda CX-5',
      'Mazda CX-50',
      'Mazda CX-30',
      'Subaru Forester',
      'Subaru Outback',
      'Volkswagen Tiguan',
      'Volkswagen Atlas',
      'Jeep Cherokee',
      'Jeep Compass',
      'Buick Envision',
      'Buick Encore GX'
    ]
  },
  minivan: {
    name: 'Minivan',
    models: [
      'Chrysler Pacifica',
      'Chrysler Voyager',
      'Honda Odyssey',
      'Toyota Sienna',
      'Kia Carnival',
      'Dodge Grand Caravan (legacy)',
      'Nissan Quest (legacy)'
    ]
  }
};

export const aspectRatioOptions = [
  { 
    id: 'landscape', 
    name: 'Landscape', 
    description: 'Perfect for web banners and social media posts',
    dimensions: '1200x800',
    ratio: '3/2',
    width: 1200,
    height: 800
  },
  { 
    id: 'square', 
    name: 'Square', 
    description: 'Ideal for Instagram posts and profile images',
    dimensions: '1024x1024',
    ratio: '1/1',
    width: 1024,
    height: 1024
  },
  { 
    id: 'portrait', 
    name: 'Portrait', 
    description: 'Perfect for mobile displays and stories',
    dimensions: '800x1200',
    ratio: '2/3',
    width: 800,
    height: 1200
  },
  { 
    id: 'banner', 
    name: 'Wide Banner', 
    description: 'Great for website headers and wide displays',
    dimensions: '1200x400',
    ratio: '3/1',
    width: 1200,
    height: 400
  },
  { 
    id: 'print', 
    name: 'Print Ready', 
    description: 'Traditional print advertising format',
    dimensions: '1200x900',
    ratio: '4/3',
    width: 1200,
    height: 900
  }
];

export const textPositionOptions = [
  { id: 'top-left', name: 'Top Left' },
  { id: 'top-center', name: 'Top Center' },
  { id: 'top-right', name: 'Top Right' },
  { id: 'center-left', name: 'Center Left' },
  { id: 'center', name: 'Center' },
  { id: 'center-right', name: 'Center Right' },
  { id: 'bottom-left', name: 'Bottom Left' },
  { id: 'bottom-center', name: 'Bottom Center' },
  { id: 'bottom-right', name: 'Bottom Right' }
];

export const fontStyleOptions = [
  { id: 'bold', name: 'Bold', description: 'Strong, impactful text' },
  { id: 'elegant', name: 'Elegant', description: 'Light and sophisticated' },
  { id: 'modern', name: 'Modern', description: 'Clean and contemporary' },
  { id: 'classic', name: 'Classic', description: 'Traditional serif style' },
  { id: 'dynamic', name: 'Dynamic', description: 'Bold uppercase with spacing' }
];

export const offerTemplates = [
  {
    id: 'financing',
    name: '0% APR Financing',
    template: '{{rate}}% APR for {{term}} months',
    fields: ['rate', 'term'],
    category: 'financing'
  },
  {
    id: 'lease-deal',
    name: 'Lease Special',
    template: 'Lease for ${{payment}}/mo for {{term}} months',
    fields: ['payment', 'term'],
    category: 'lease'
  },
  {
    id: 'cashback',
    name: 'Cash Back Offer',
    template: 'Get ${{amount}} Cash Back',
    fields: ['amount'],
    category: 'incentive'
  },
  {
    id: 'trade-in',
    name: 'Trade-In Bonus',
    template: 'Up to ${{amount}} for your trade-in',
    fields: ['amount'],
    category: 'trade'
  },
  {
    id: 'msrp-discount',
    name: 'MSRP Discount',
    template: '${{amount}} off MSRP',
    fields: ['amount'],
    category: 'discount'
  },
  {
    id: 'payment-special',
    name: 'Low Payment',
    template: 'Payments as low as ${{payment}}/mo',
    fields: ['payment'],
    category: 'payment'
  },
  {
    id: 'no-payment',
    name: 'Skip Payments',
    template: 'No payments for {{months}} months',
    fields: ['months'],
    category: 'payment'
  },
  {
    id: 'warranty',
    name: 'Extended Warranty',
    template: '{{years}} year/{{miles}}k mile warranty',
    fields: ['years', 'miles'],
    category: 'warranty'
  },
  {
    id: 'limited-time',
    name: 'Limited Time',
    template: 'Limited time offer - Ends {{date}}',
    fields: ['date'],
    category: 'urgency'
  },
  {
    id: 'certified',
    name: 'Certified Pre-Owned',
    template: 'Certified Pre-Owned from ${{price}}',
    fields: ['price'],
    category: 'certified'
  },
  {
    id: 'new-arrival',
    name: 'New Model',
    template: 'New {{year}} {{model}} - Now Available',
    fields: ['year', 'model'],
    category: 'new'
  },
  {
    id: 'clearance',
    name: 'Clearance Sale',
    template: '{{percent}}% off all {{year}} models',
    fields: ['percent', 'year'],
    category: 'sale'
  }
];

export const sceneOptions = [
  { id: 'showroom', name: 'Modern Showroom', description: 'Clean, modern dealership showroom with professional lighting' },
  { id: 'city', name: 'Urban Setting', description: 'City skyline background with modern architecture' },
  { id: 'highway', name: 'Open Highway', description: 'Scenic highway with mountains or countryside' },
  { id: 'luxury', name: 'Luxury Estate', description: 'Upscale mansion or luxury hotel setting' },
  { id: 'nature', name: 'Natural Landscape', description: 'Beautiful natural scenery with trees and mountains' },
  { id: 'studio', name: 'Studio Setting', description: 'Professional photography studio with gradient background' },
  { id: 'parking', name: 'Dealership Lot', description: 'Well-organized dealership parking lot' },
  { id: 'sunset', name: 'Golden Hour', description: 'Dramatic sunset lighting with warm tones' }
];

export const seasonOptions = [
  { id: 'spring', name: 'Spring', description: 'Fresh green foliage and blooming flowers' },
  { id: 'summer', name: 'Summer', description: 'Bright sunny day with lush greenery' },
  { id: 'autumn', name: 'Autumn', description: 'Colorful fall foliage and warm lighting' },
  { id: 'winter', name: 'Winter', description: 'Snow-covered landscape with crisp lighting' }
];

export const promotionTypes = [
  { id: 'sale', name: 'Sale Event', text: 'SALE' },
  { id: 'new', name: 'New Arrival', text: 'NEW' },
  { id: 'limited', name: 'Limited Edition', text: 'LIMITED' },
  { id: 'special', name: 'Special Offer', text: 'SPECIAL OFFER' },
  { id: 'financing', name: 'Financing Available', text: '0% APR' },
  { id: 'lease', name: 'Lease Special', text: 'LEASE SPECIAL' },
  { id: 'certified', name: 'Certified Pre-Owned', text: 'CERTIFIED' },
  { id: 'none', name: 'No Promotion', text: '' }
];

export const styleOptions = [
  { id: 'photorealistic', name: 'Photorealistic', description: 'Ultra-realistic photography style' },
  { id: 'cinematic', name: 'Cinematic', description: 'Movie-like dramatic lighting and composition' },
  { id: 'commercial', name: 'Commercial', description: 'Professional advertising photography' },
  { id: 'artistic', name: 'Artistic', description: 'Creative and stylized approach' },
  { id: 'minimalist', name: 'Minimalist', description: 'Clean and simple composition' }
];